import { render, staticRenderFns } from "./gameMenu.vue?vue&type=template&id=cd03aaf2&scoped=true&"
import script from "./gameMenu.vue?vue&type=script&lang=js&"
export * from "./gameMenu.vue?vue&type=script&lang=js&"
import style0 from "./gameMenu.vue?vue&type=style&index=0&id=cd03aaf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd03aaf2",
  null
  
)

component.options.__file = "gameMenu.vue"
export default component.exports